module.exports = __webpack_public_path__ + "img/sl_1.de179d92.jpg";